import { createFileRoute } from '@tanstack/react-router'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ApiKeysSettings } from '@/components/settings/ApiKeysSettings'
import { BudgetSettings } from '@/components/budget/BudgetSettings'
import { OrganizationsSettings } from '@/components/settings/OrganizationsSettings'
import { PageHeader } from '@/components/shared/PageHeader'

export const Route = createFileRoute('/_authenticated/ustawienia')({
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Ustawienia"
        subtitle="Zarządzaj kluczami API, budżetem i organizacjami"
      />

      <Tabs defaultValue="api-keys" className="space-y-4">
        <TabsList>
          <TabsTrigger value="api-keys">Klucze API</TabsTrigger>
          <TabsTrigger value="budget">Budżet API</TabsTrigger>
          <TabsTrigger value="organizations">Organizacje</TabsTrigger>
        </TabsList>

        <TabsContent value="api-keys">
          <ApiKeysSettings />
        </TabsContent>

        <TabsContent value="budget">
          <BudgetSettings />
        </TabsContent>

        <TabsContent value="organizations">
          <OrganizationsSettings />
        </TabsContent>
      </Tabs>
    </div>
  )
}
